import React, { useEffect, useState } from "react";
import "./Prayer.css";
import AudioPlayer from "react-h5-audio-player";
// import "react-h5-audio-player/lib/styles.css";
import { Link } from "react-router-dom";

const Prayer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");

    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);
  return (
    <>
      {/* <div>
                <div class="wrapper" id="cover">
                    <img
                        src={require("../../../Assets/images/muslim-praying-in-sujud-posture-overlay.png")}
                        class="prx"
                        style={{ height: "205px", width: "100%" }}
                    />
                 </div>
            </div> */}
      <section style={{ marginBottom: "60px" }}>
        <div class="salah">
          <img
            src={require("../../../Assets/images/prayer.png")}
            alt="prayer"
          />
          <div class="rbloc">
            <h1>
              {rtl
                ? `العبادة (صلاة)`
                : fr
                ? "LA PRIÈRE (salah)"
                : `Prayer (salah)`}
            </h1>
            <p>
              {rtl
                ? `كيف يظهر المسلمون خضوعهم الجسدي والروحي لله من قبل الأكثر
شهرة ، والواجب في الإسلام هو أداء الصلوات الخمس اليومية.`
                : fr
                ? `Les musulmans montrent leur soumission physique et spirituelle à
                Allah (Dieu) par l'acte le plus connu et le plus obligatoire de l'islam, à
                savoir l'accomplissement des cinq prières quotidiennes.`
                : `How Muslims show both their physical and spiritual
                            submission to Allah by the most well-known, and an
                            obligatory act in Islam is the performance of the
                            five daily prayers.`}
            </p>
            <AudioPlayer
              src={require("../../../Assets/Adhan.mp3")}
              onPlay={(e) => console.log("onPlay")}
            />
          </div>
        </div>
        <div class="t-bg-bloc">
          <div class="t-bloc-card th-layer">
            <img
              src={require("../../../Assets/images/islam.png")}
              alt="islam"
              class="itbloc"
            />
            <p>
              {rtl
                ? `في الإسلام تعتبر الصلاة والدعاء
ومعظم الشعائر من العبادات، وأحد
أهدافنا في مكة والمدينة القابضة هو
الاستثمار في بناء المساجد الحديثة
في العديد من البلدان لتقريب
المسلمين من الله وأيضا بناء
شخصية أفراد المجتمع الإسلامي.
المعنى الأخلاقي لهذا هو أن يمنعنا
من الأنشطة غير اللائقة والمخزية.`
                : fr
                ? `Dans l'islam, la prière, la supplication,
                la purification et la plupart des actions
                rituelles sont considérées comme des
                actes de culte. L'un des objectifs de
                MMH est d'investir dans la
                construction de mosquées modernes
                dans de nombreux pays afin de
                rapprocher les musulmans d'Allah et
                de former le caractère des membres
                de la communauté islamique. Le sens
                moral de cette démarche est de nous
                éloigner des activités indécentes et
                honteuses.`
                : `In Islam, prayer, supplication, purification and
                            most ritual actions are considered acts of worship,
                            and one of our goals in MMH is to invest to build
                            Modern mosques in many countries to bring the
                            Muslims closer to Allah and also build the character
                            of members of Islamic community. The moral sense of
                            this is to keeps us from indecent, shameful
                            activities.`}
            </p>
          </div>
          <div class="t-bloc-card">
            <img
              src={require("../../../Assets/images/mosque.png")}
              alt="mosque"
              class="itbloc"
            />
            <p>
              {rtl
                ? `مساجدنا ليست مجرد مسجد للصلاة
بل هي مركز مجتمعي للجميع.
يلتزم المركز بالحفاظ على الهوية
الإسلامية، وبناء ودعم مجتمع مسلم
قابل للحياة، وتعزيز أسلوب حياة
إسلامي شامل يستند إلى القرآن
الكريم والسنة النبوية الشريفة.`
                : fr
                ? `Notre mosquée n'est pas seulement
                une mosquée pour les prières, c'est
                aussi un centre communautaire pour
                tous. Le centre s'engage à préserver
                une identité islamique, à construire
                et à soutenir une communauté
                musulmane viable, à promouvoir un
                mode de vie islamique complet basé
                sur le Saint Coran et la Sounnah du
                Prophète Muhammad (que la paix
                soit avec lui).`
                : `Our mosques is not just a mosque for prayers rather
                            it is a community center for all. The Center is
                            committed to preserving an Islamic identity,
                            building and supporting a viable Muslim community,
                            promoting a comprehensive Islamic way of life based
                            on the Holy Quran and the Sunnah of Prophet Muhammad
                            (Peace Be upon Him).`}
            </p>
          </div>
          <div class="t-bloc-card">
            <img
              src={require("../../../Assets/images/quran.png")}
              alt="quran"
              class="itbloc"
            />
            <p>
              {rtl
                ? `يتم إعطاء العمل أهمية خاصة بقدر
ما يعتبر عملا من أعمال العبادة في
حد ذاته. هذا هو السبب في أن مكة
والمدينة القابضة تشجع بشكل كبير
الأعمال لأنها تساهم بشكل مباشر
في تحسين مستوى المعيشة وتوفير
وسائل الراحة الدنيوية.`
                : fr
                ? `Une importance particulière est
                accordée au travail, au point qu'il
                est considéré comme un acte de
                culte en soi. C'est pourquoi le
                MMH LTD encourage vivement le
                commerce, car il contribue
                directement à améliorer le
                niveau de vie et à apporter le
                confort matériel.`
                : `Work is given special importance to the extent that
                            it is considered as an act of worship itself. that’s
                            why MMH LTD greatly encourages business because it
                            directly contributes to improving the standard of
                            living and providing worldly comforts.`}
            </p>
          </div>
          <div class="t-bloc-card">
            <img
              src={require("../../../Assets/images/islam-.png")}
              alt="islam-"
              class="itbloc"
            />
            <p>
              {rtl
                ? `يشجع الإسلام المسلمين على العمل
الجاد والإخلاص والصدق والتفوق
في المعاملات التجارية. أنت تعد
الأرض وتطورها لصالح البشر
ومجد الله. أنت خليفة الله، وهو
يعمل من خلالك. لهذا السبب ،
ستخلق مكة والمدينة القابضة العديد
من الفرص والوظائف في جميع
أنحاء العالم من خلال تقديم قروض
طويلة الأجل بدون فوائد للشركات
الصغيرة والشركات الناشئة.`
                : fr
                ? `L'islam encourage les musulmans à
                travailler dur, à être sincères et
                véridiques, et à exceller dans les
                transactions commerciales. Vous
                préparez et développez la terre pour
                le bénéfice des humains et la gloire de
                Dieu. Vous êtes le masque de Dieu, et
                il travaille à travers vous. C'est
                pourquoi, MMH créera de nombreuses
                opportunités et emplois à travers le
                monde en offrant des prêts à long
                terme, sans intérêt, pour les petites
                entreprises et les startups.`
                : `Islam encourages Muslims to work hard, be sincere
                            and truthful, and excel in business transactions.
                            You prepare and develop the earth for the benefit of
                            humans and the glory of God. You are God's mask, and
                            he is working through you. That's why, MMH will
                            create many opportunities and jobs across the world
                            by offering long-term, interest-free loans for the
                            small business and startups.`}
            </p>
          </div>
        </div>
      </section>
      <div class="container">
        <div class="plrs-wrap text-center remove-ext5">
          <div
            class="row"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div class="col-md-3 col-sm-6 col-lg-2 plrs ">
              <Link to="/five-pillars-shahada">
                <div class="plr-box ">
                  <i class="flaticon-clicker"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `الشهادتان` : `Shahadah`}</h4>
                    <p>({rtl ? `ايمان` : fr ? "La foi" : `Faith`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-prayer">
                <div class="plr-box">
                  <i class="flaticon-islamic-pray"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `إقامِ الصلاةِ` : `Salah`}</h4>
                    <p>({rtl ? `صلاة` : fr ? "Prière" : `Prayer`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-fasting">
                <div class="plr-box">
                  <i class="flaticon-islamic-ramadan"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `صومِ رمضانَ` : `Sawm`}</h4>
                    <p>({rtl ? `صوم` : fr ? "Le jeûne" : `Fasting`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-zakat">
                <div class="plr-box">
                  <i class="flaticon-charity"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `إيتاءِ الزّكاةِ` : `Zakat`}</h4>
                    <p>({rtl ? `الصدقة` : fr ? "L'aumône" : `Almsgiving`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 ">
              <Link to="/five-pillars-pilgrimage">
                <div class="plr-box">
                  <i class="flaticon-kaaba-building"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `الحجِّ` : `Hajj`}</h4>
                    <p>({rtl ? `حج` : fr ? "Pèlerinage" : `Pilgrimage`})</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Prayer;
